import { type FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from '@kanda-libs/ks-design-library';

import PageTitle from 'components/shared/PageTitle';

import UserModal from './UserModal';
import useUsersListPage from './useUsersListPage';

import UserTable from '../UserTable';

const UsersListPage: FunctionComponent = () => {
  const { modalProps, clearModalProps, ...userList } = useUsersListPage();

  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Users</PageTitle>
        <UserTable {...userList} />
        <UserModal {...modalProps} closeCallback={clearModalProps} />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default UsersListPage;
